var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "selector-popup",
    {
      ref: "popup",
      attrs: { header: "What would you like to do?", items: _vm.items },
    },
    [
      _c("i", { attrs: { slot: "descriptionTop" }, slot: "descriptionTop" }, [
        _vm._v("\n        You can either "),
        _c("strong", [_vm._v("Create New Chat")]),
        _vm._v("\n        or "),
        _c("strong", [
          _vm._v('Join last Chat "' + _vm._s(_vm.lastChat.name) + '"'),
        ]),
        _vm._v("\n        created by\n        "),
        _vm.lastChat.created_by
          ? _c(
              "strong",
              [
                _c("simple-link", {
                  attrs: { target: _vm.lastChat.created_by },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(
          "\n        on " +
            _vm._s(_vm._f("gbdate")(_vm.lastChat.created_at)) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-mm btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("Cancel")]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }